import {AfterViewInit, Directive, ElementRef, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {Modal} from "bootstrap";
import {EventUtils} from "@wba/utils/event.utils";

export interface ModalOptions {
  backdrop: boolean | 'static';
  keyboard: boolean;
  focus: boolean;
  show: boolean;
}

@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class AbstractDialogComponent implements AfterViewInit {

  @ViewChild('modalDialogEl') modalDialogEl: ElementRef;

  protected options: ModalOptions = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };

  /**
   * Wird gefeuert, wenn das Dialogfenster geschlossen wird
   * Fokus sollte hier nicht mehr gesetzt werden,
   * statt dessen sollte das Element, welches fokusiert werden soll
   * über dem Parameter der Funktion open gesetzt werden
   */
  afterClosedEvent$ = new Subject();

  protected modalElement: Modal;

  // kann eigentlich statisch als Input übergeben werden?
  protected invokerElement?: HTMLElement

  ngAfterViewInit(): void {
    this.modalElement = new Modal(this.modalDialogEl.nativeElement, this.options)
    this.modalDialogEl.nativeElement.addEventListener("hidden.bs.modal", () => this.close())
  }

  open(invokerElement?: HTMLElement) {

    this.modalElement.show();
    this.invokerElement = invokerElement;
  }

  close() {

    this.afterClosedEvent$.next(null)
    if (EventUtils.isVisible(this.invokerElement)) {
      EventUtils.focus(this.invokerElement);
    }
  }
}
